import { useParams } from 'react-router-dom';
import keys from './keys';
import useApiQuery from '../../../useApiQuery';

const useGetMarketplaceShowProfile = ({
  showId: showIdParam,
  profileId: profileIdParam,
  disabled,
  shouldRefetch = () => false,
} = {}) => {
  const { showId: currentShowId, profileId: currentProfileId } = useParams();
  const showId = showIdParam || currentShowId;
  const profileId = profileIdParam || currentProfileId;

  const query = useApiQuery({
    queryKey: keys.showProfile({ showId, profileId }),
    requestUrl: `/shows/${showId}/marketplace/profiles/${profileId}`,
    disabled: disabled || !showId || !profileId,
    refetchInterval: (profile) => (shouldRefetch(profile) ? 5000 : false),
    refetchOnMount: (profile) => (shouldRefetch(profile) ? 5000 : false),
  });

  return {
    showProfile: query.data,
    showProfileError: query.error,
    isShowProfileFetchError: query.isError,
    isShowProfileFetchSuccess: query.isSuccess,
    isShowProfileFetching: query.isFetching,
    isShowProfileLoading: query.isInitialLoading,
    refetchShowProfile: query.refetch,
    ...query,
  };
};

export default useGetMarketplaceShowProfile;
